/*
This file was generated by the Surface compiler.
*/

export const RepresentationTypeSelector = {
  mounted() {
    this.el.addEventListener("input", (e) => {
      e.stopImmediatePropagation()
      this.pushEventTo(this.el, "representation_type_changed", e.target.value)
    })
  },
}
